// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.override-question[data-v-400d7462] {\n    font-size: 1.2em;\n    color: #444444;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
